function StarRateEmpty({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.15716 15.3028L10 13.1114L12.8428 15.3028L11.7768 11.69L14.4419 9.79478H11.1253L10 6.12278L8.87471 9.79478H5.55806L8.22322 11.69L7.15716 15.3028ZM3.79046 20.0681L6.12307 12.4099L0 8.018H7.5901L10 0L12.4099 8.018H20L13.8769 12.4099L16.2095 20.0681L10 15.3437L3.79046 20.0681Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default StarRateEmpty;
